var EventManager =
/** @class */
function () {
  function EventManager() {
    var _this = this;

    this.listeners = new Map();

    this.on = function (event, listener) {
      var _a, _b;

      var newListeners = (_b = (_a = _this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.add(listener)) !== null && _b !== void 0 ? _b : new Set([listener]);

      _this.listeners.set(event, newListeners);
    };

    this.off = function (event, listener) {
      var _a;

      (_a = _this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.delete(listener);
    };

    this.emit = function (event, data) {
      var listeners = _this.listeners.get(event);

      if (listeners && listeners.size > 0) {
        listeners.forEach(function (callback) {
          callback(data);
        });
      }
    };

    this.removeAllListeners = function () {
      _this.listeners = new Map();
    };
  }

  return EventManager;
}();

export { EventManager };